import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "messages"
}
const _hoisted_2 = {
  key: 0,
  class: "message success"
}
const _hoisted_3 = {
  key: 0,
  class: "message info"
}
const _hoisted_4 = {
  key: 0,
  class: "message failure"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "message warning"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_CollapseTransition = _resolveComponent("CollapseTransition")!

  return (_openBlock(), _createBlock(_component_CollapseTransition, null, {
    default: _withCtx(() => [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_CollapseTransition, null, {
              default: _withCtx(() => [
                (_ctx.flash?.success)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_component_SvgIcon, {
                        class: "message-icon",
                        type: "mdi",
                        path: _ctx.successIcon
                      }, null, 8, ["path"]),
                      _createElementVNode("p", null, _toDisplayString(_ctx.flash.success.text), 1),
                      _createVNode(_component_SvgIcon, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = false)),
                        class: "close-icon",
                        type: "mdi",
                        path: _ctx.closeIcon
                      }, null, 8, ["path"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_CollapseTransition, null, {
              default: _withCtx(() => [
                (_ctx.flash?.message)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_SvgIcon, {
                        class: "message-icon",
                        type: "mdi",
                        path: _ctx.infoIcon
                      }, null, 8, ["path"]),
                      _createElementVNode("p", null, _toDisplayString(_ctx.flash.message.text), 1),
                      _createVNode(_component_SvgIcon, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.show = false)),
                        class: "close-icon",
                        type: "mdi",
                        path: _ctx.closeIcon
                      }, null, 8, ["path"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_CollapseTransition, null, {
              default: _withCtx(() => [
                (_ctx.flash?.failure)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_SvgIcon, {
                        class: "message-icon",
                        type: "mdi",
                        path: _ctx.dangerIcon
                      }, null, 8, ["path"]),
                      (typeof _ctx.failureMessage === 'string')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.failureMessage), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("h3", null, _toDisplayString(_ctx.failureMessage.title), 1),
                            (_ctx.failureMessage.is_html)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 0,
                                  innerHTML: _ctx.failureMessage.message
                                }, null, 8, _hoisted_7))
                              : (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.failureMessage.message), 1))
                          ])),
                      _createVNode(_component_SvgIcon, {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.show = false)),
                        class: "close-icon",
                        type: "mdi",
                        path: _ctx.closeIcon
                      }, null, 8, ["path"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_CollapseTransition, null, {
              default: _withCtx(() => [
                (_ctx.flash?.warning)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_SvgIcon, {
                        class: "message-icon",
                        type: "mdi",
                        path: _ctx.infoIcon
                      }, null, 8, ["path"]),
                      _createElementVNode("p", null, _toDisplayString(_ctx.flash.warning.text), 1),
                      _createVNode(_component_SvgIcon, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.show = false)),
                        class: "close-icon",
                        type: "mdi",
                        path: _ctx.closeIcon
                      }, null, 8, ["path"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}